var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OOI_WIDGET_COMPONENT_TYPE, } from './constants';
import { ViewerScriptFlowAPI, ControllerFlowAPI, } from './flow-api/ViewerScript';
import { wrapUserController } from './helpers/wrapUserController';
import { createDangerousPublicDataOverride } from './helpers/createDangerousPublicDataOverride';
var viewerScriptFlowAPI;
var viewerScriptTranslationsPromise;
var appData = {};
var getFirstDescriptor = function (descriptors) {
    if (descriptors.length === 1) {
        return descriptors[0];
    }
};
var defaultControllerWrapper = function (controllerDescriptor, controllerConfig) {
    var flowAPI = new ControllerFlowAPI({
        viewerScriptFlowAPI: viewerScriptFlowAPI,
        appDefinitionId: controllerDescriptor.appDefinitionId,
        widgetId: controllerDescriptor.id,
        translationsConfig: controllerDescriptor.translationsConfig,
        biLogger: controllerDescriptor.biLogger,
        controllerConfig: controllerConfig,
    });
    var dangerousPublicDataOverride = createDangerousPublicDataOverride(flowAPI);
    return controllerDescriptor.method({
        controllerConfig: controllerConfig,
        flowAPI: flowAPI,
        appData: appData,
        dangerousPublicDataOverride: dangerousPublicDataOverride,
    });
};
function ooiControllerWrapper(optionalDeps, controllerDescriptor, controllerConfig) {
    var setProps = controllerConfig.setProps, appParams = controllerConfig.appParams;
    var setState = function (newState) {
        var updatedState = __assign(__assign({}, context.state), newState);
        // Track state
        context.state = updatedState;
        // Run state change callback
        wrappedController.then(function (userController) {
            if (userController.stateChange) {
                userController.stateChange();
            }
        });
        // Update render cycle
        return setProps({ state: updatedState });
    };
    var context = {
        state: {},
        setState: setState,
    };
    var appDefinitionId = appParams.appDefinitionId;
    var flowAPI = new ControllerFlowAPI({
        viewerScriptFlowAPI: viewerScriptFlowAPI,
        appDefinitionId: appDefinitionId,
        translationsConfig: controllerDescriptor.translationsConfig,
        widgetId: controllerDescriptor.id,
        biLogger: controllerDescriptor.biLogger,
        controllerConfig: controllerConfig,
    });
    var dangerousPublicDataOverride = createDangerousPublicDataOverride(flowAPI);
    var userControllerPromise = controllerDescriptor.method.call(context, {
        controllerConfig: flowAPI.controllerConfig,
        flowAPI: flowAPI,
        appData: appData,
        dangerousPublicDataOverride: dangerousPublicDataOverride,
    });
    var wrappedController = Promise.all([
        viewerScriptTranslationsPromise,
        flowAPI.getExperiments(),
        Promise.resolve(userControllerPromise).catch(function (error) {
            if (!flowAPI.inEditor) {
                // Currently platform doesn't log errors happened in worker. We want to fix it here.
                console.error("\u2757\uFE0FError \uD83D\uDC49 \"" + controllerDescriptor.appName + "\" app \uD83D\uDC49 " + controllerDescriptor.componentName + " controller \u2757\n", error);
                flowAPI.reportError(error);
            }
            return { _controllerError: error };
        }),
    ]).then(function (_a) {
        var translations = _a[0], experiments = _a[1], userController = _a[2];
        return wrapUserController({
            controller: userController,
            translations: translations,
            experiments: experiments,
            biLogger: flowAPI.biLogger,
            controllerConfig: controllerConfig,
            flowAPI: flowAPI,
            experimentsConfig: controllerDescriptor.experimentsConfig,
            translationsConfig: controllerDescriptor.translationsConfig,
            state: context.state,
            _controllerError: userController._controllerError,
            optionalDeps: optionalDeps,
        });
    });
    return wrappedController;
}
var wrapControllerByWidgetType = function (optionalDeps, controllerDescriptor, controllerConfig) {
    switch (controllerDescriptor.widgetType) {
        case OOI_WIDGET_COMPONENT_TYPE:
            return ooiControllerWrapper(optionalDeps, controllerDescriptor, controllerConfig);
        default:
            return defaultControllerWrapper(controllerDescriptor, controllerConfig);
    }
};
var getDescriptorForConfig = function (type, descriptors) {
    return (descriptors.find(function (descriptor) { return descriptor.id === type; }) ||
        getFirstDescriptor(descriptors));
};
export var createControllers = function (optionalDeps, createController, translationsConfig, experimentsConfig, defaultTranslations, biConfig, biLogger, projectName, appDefinitionId, componentId) {
    if (translationsConfig === void 0) { translationsConfig = null; }
    if (experimentsConfig === void 0) { experimentsConfig = null; }
    if (defaultTranslations === void 0) { defaultTranslations = null; }
    return createControllersWithDescriptors(optionalDeps, [
        {
            method: createController,
            projectName: projectName,
            id: componentId,
            biConfig: biConfig,
            translationsConfig: translationsConfig,
            defaultTranslations: defaultTranslations,
            biLogger: biLogger,
            widgetType: OOI_WIDGET_COMPONENT_TYPE,
            experimentsConfig: experimentsConfig,
            controllerFileName: null,
            componentName: null,
            appName: null,
            appDefinitionId: appDefinitionId,
        },
    ]);
};
var getControllerFromControllerModule = function (controllerModule) {
    // controller was exported as `module.exports = controller`
    if (typeof controllerModule === 'function') {
        return controllerModule;
    }
    // controller was exported as `export default controller` or `export const controller`
    var controllerKey = Object.keys(controllerModule).find(function (key) {
        return key.toLowerCase().includes('controller');
    }) || 'default';
    var controller = controllerModule[controllerKey];
    if (typeof controller !== 'function') {
        throw new Error("Seems like a bundle you have registered as Controller URL in Dev Center doesn't contain exported controller.\nPlease, verify you are using relevant controller bundle generated by editor flow.");
    }
    return controller;
};
// imported from code generation wrappers/templates/CommonViewerScriptEntry.ts
export var createControllersWithDescriptors = function (optionalDeps, controllerDescriptors, createControllersStrategy) {
    if (createControllersStrategy === void 0) { createControllersStrategy = null; }
    return function (controllerConfigs, controllerModulesMap) {
        var wrappedControllers = controllerConfigs.map(function (controllerConfig) {
            // [Platform surprise] `type` here, is a widgetId. :(
            var widgetId = controllerConfig.type;
            var controllerDescriptor = getDescriptorForConfig(widgetId, controllerDescriptors);
            if (!controllerDescriptor) {
                throw new Error("Descriptor for widgetId: \"" + widgetId + "\" was not found. Please create a \".component.json\" file for current widget");
            }
            var controllerModule = controllerModulesMap === null || controllerModulesMap === void 0 ? void 0 : controllerModulesMap[widgetId];
            var shouldUseExternalController = createControllersStrategy === 'controller';
            if (shouldUseExternalController) {
                if (!controllerModule) {
                    return;
                }
                controllerDescriptor.method = getControllerFromControllerModule(controllerModule);
            }
            return wrapControllerByWidgetType(optionalDeps, controllerDescriptor, controllerConfig);
        });
        return wrappedControllers;
    };
};
export var initAppForPageWrapper = function (_a) {
    var initAppForPage = _a.initAppForPage, _b = _a.sentryConfig, sentryConfig = _b === void 0 ? null : _b, _c = _a.experimentsConfig, experimentsConfig = _c === void 0 ? null : _c, _d = _a.inEditor, inEditor = _d === void 0 ? false : _d, projectName = _a.projectName, defaultTranslations = _a.defaultTranslations, translationsConfig = _a.translationsConfig, biConfig = _a.biConfig, biLogger = _a.biLogger, _e = _a.appName, appName = _e === void 0 ? null : _e, optionalDeps = _a.optionalDeps;
    return function (initParams, platformAPIs, namespaces, platformServices) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    viewerScriptFlowAPI = new ViewerScriptFlowAPI({
                        experimentsConfig: experimentsConfig,
                        projectName: projectName,
                        sentryConfig: sentryConfig,
                        platformServices: platformServices,
                        wixAPI: namespaces,
                        appData: initParams,
                        translationsConfig: translationsConfig,
                        defaultTranslations: defaultTranslations,
                        inEditor: inEditor,
                        biConfig: biConfig,
                        biLogger: biLogger,
                        appName: appName,
                        optionalDeps: optionalDeps,
                    });
                    viewerScriptTranslationsPromise = (_a = viewerScriptFlowAPI.translations) === null || _a === void 0 ? void 0 : _a.init();
                    return [4 /*yield*/, viewerScriptTranslationsPromise];
                case 1:
                    _b.sent();
                    if (!initAppForPage) return [3 /*break*/, 5];
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, initAppForPage(initParams, platformAPIs, namespaces, platformServices, viewerScriptFlowAPI)];
                case 3:
                    appData = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    if (!inEditor) {
                        // Currently platform doesn't log errors happened in worker. We want to fix it here.
                        console.error("\u2757\uFE0FError \uD83D\uDC49 \"" + appName + "\" app \uD83D\uDC49 `viewer.app.ts` module \u2757\n", e_1);
                        viewerScriptFlowAPI.reportError(e_1);
                    }
                    throw e_1;
                case 5: 
                // appData will be available in controllers
                return [2 /*return*/, appData];
            }
        });
    }); };
};
//# sourceMappingURL=viewerScript.js.map